export default __webpack_public_path__ + "static/media/_iceball.43b8aa10.png";